import { Button, ExclamationCircle } from "@au-schein-de/au-ui-library";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useDisclosure } from "~/hooks/use-disclosure";
import { Logo } from "./logo.component";

export const ErrorPage = ({
	title,
	message,
	primaryButton,
	debugInfo,
	errorId,
}: {
	title: string;
	message: string;
	primaryButton?: {
		label: string;
		action: () => void;
	};
	debugInfo?: ReactNode;
	errorId?: string;
}) => {
	const { t } = useTranslation();
	const debugInfoDisclosure = useDisclosure();

	return (
		<div className="bg-white w-full min-h-screen flex flex-col justify-between">
			<div className="px-4 md:px-10 pt-14 grow">
				<Logo />
			</div>
			<div className="w-full md:max-w-5/12 self-center px-4 md:px-10">
				<div>
					<div className="flex items-center gap-2">
						<ExclamationCircle.Raw className="h-8 text-error-400" />
						<span className="text-h3">
							{title ?? t("errors.somethingWentWrong")}
						</span>
					</div>
				</div>

				<div className="mt-2">
					<span className="text-body text-gray-500">{message}</span>
				</div>

				<div className="mt-8">
					<div className="flex flex-col w-full gap-2">
						{primaryButton && (
							<Button
								size="md"
								variant="primary"
								className="flex flex-grow"
								onClick={primaryButton.action}
							>
								{primaryButton.label}
							</Button>
						)}
					</div>
				</div>

				{errorId && (
					<div className="mt-6">
						<span className="text-body text-gray-500">
							{t("errors.errorId")}: {errorId}
						</span>
					</div>
				)}
			</div>

			{debugInfo && (
				<>
					<Button
						variant="ghost"
						className="text-body text-gray-500 mt-6"
						onClick={debugInfoDisclosure.toggle}
					>
						[DEV MODE] Toggle debug info
					</Button>
					{debugInfoDisclosure.isOpen && debugInfo}
				</>
			)}

			<div className="grow pb-14" />
		</div>
	);
};
